module.exports = __webpack_public_path__ + "img/Butterfly_00205.8a24fd88.png";